module.exports = __webpack_public_path__ + "img/mdi-hospital.1ddd759e.svg";